<rap-add-edit-rosters-ui [editableRoster]="editableRoster$ | async" [students]="students$ | async"
  [errorMessage]="errorMessage$ | async" [title]="title" (createNewRosterEmitter)="createNewRoster($event)"
  (updateRosterEmitter)="updateRoster($event)"></rap-add-edit-rosters-ui>